import { ContactTypeEnum } from '../enums';

export class ContactTypeResult {
    public id: number = 0;
    public name: string = '';
    public contactTypeEnum: ContactTypeEnum = ContactTypeEnum.Other;
    public isDeleted: boolean = false;
}
